import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X, MessageCircle } from "lucide-react";
import { LOGO } from "../lib/constants";

const links = [
  { to: "/", label: "Accueil" },
  { to: "/services", label: "Services" },
  { to: "/frontaliers", label: "Frontaliers" },
  { to: "/guides-fiscaux-frontaliers", label: "Guides fiscaux" },
  { to: "/outils-frontaliers", label: "Outils" },
  { to: "/independants-entreprises", label: "Entreprises" },
  { to: "/faq", label: "FAQ" },
];

export const Navbar = ({ onOpenChat }) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-white/75 border-b border-[#C4C8CC]/40">
      <div className="max-w-7xl mx-auto px-5 lg:px-6 h-[76px] flex items-center justify-between gap-4">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3 shrink-0 mr-6 xl:mr-10">
          <img src={LOGO} alt="Fiscoconseils" className="h-11 w-11 object-contain" />
          <span className="font-heading text-[22px] font-semibold tracking-tight text-[#0A1128] hidden sm:inline">Fiscoconseils</span>
        </Link>

        <nav className="hidden lg:flex items-center gap-4 xl:gap-6 2xl:gap-7">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.to === "/" ? "home" : l.to.slice(1)}`}
              end={l.to === "/"}
              className={({ isActive }) =>
                `text-[13px] xl:text-sm font-medium tracking-wide whitespace-nowrap transition-colors duration-200 ${l.to === "/" ? "hidden 2xl:inline-block" : ""} ${
                  isActive ? "text-[#0A1128] border-b-2 border-[#0A1128] pb-1" : "text-[#4B5563] hover:text-[#0A1128]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-2.5 shrink-0">
          <Link
            data-testid="nav-client-btn"
            to="/espace-client"
            className="hidden xl:inline text-sm font-semibold text-[#4B5563] hover:text-[#0A1128] transition-colors duration-200 mr-1 whitespace-nowrap"
          >
            Espace client
          </Link>
          <button
            data-testid="nav-chat-btn"
            onClick={onOpenChat}
            className="inline-flex items-center gap-2 text-sm font-semibold text-[#0A1128] border border-[#C4C8CC] rounded-full px-4 py-2.5 hover:bg-[#F8F9FA] transition-colors duration-200 whitespace-nowrap"
          >
            <MessageCircle size={16} strokeWidth={1.75} /> <span className="hidden 2xl:inline">Conseiller IA</span><span className="2xl:hidden">IA</span>
          </button>
          <button
            data-testid="nav-devis-btn"
            onClick={() => navigate("/devis")}
            className="text-sm font-semibold text-white bg-[#0A1128] rounded-full px-5 py-2.5 hover:bg-[#1A2342] transition-colors duration-200 whitespace-nowrap"
          >
            Demander un devis
          </button>
        </div>

        <button data-testid="nav-mobile-toggle" className="lg:hidden text-[#0A1128]" onClick={() => setOpen(!open)}>
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div data-testid="nav-mobile-menu" className="lg:hidden bg-white border-t border-[#C4C8CC]/40 px-5 py-6 space-y-4">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} onClick={() => setOpen(false)} className="block text-base font-medium text-[#0A1128]">
              {l.label}
            </NavLink>
          ))}
          <NavLink to="/espace-client" onClick={() => setOpen(false)} className="block text-base font-medium text-[#0A1128]">
            Espace client
          </NavLink>
          <button
            onClick={() => { setOpen(false); onOpenChat(); }}
            className="w-full text-sm font-semibold text-[#0A1128] border border-[#C4C8CC] rounded-full px-5 py-3"
          >
            Parler au conseiller IA
          </button>
          <button
            onClick={() => { setOpen(false); navigate("/devis"); }}
            className="w-full text-sm font-semibold text-white bg-[#0A1128] rounded-full px-5 py-3"
          >
            Demander un devis
          </button>
        </div>
      )}
    </header>
  );
};
